import { EventTimer } from '@guardian/commercial-core/event-timer';
import fastdom from 'fastdom';
import { stripDfpAdPrefixFrom } from '../lib/header-bidding/utils';
import { TimedQueue } from '../lib/timed-queue';
import { refreshBidsForAd, requestBidsForAd } from './request-bids';
const eventTimer = EventTimer.get();
const adQueue = TimedQueue();
document.addEventListener('modal:open', (e) => {
    if (e.detail?.modalType === `sign-in-gate-v2`) {
        adQueue.pause();
    }
});
document.addEventListener('modal:close', (e) => {
    if (e.detail?.modalType === `sign-in-gate-v2`) {
        void adQueue.drain();
    }
});
export const loadAdvert = (advert) => {
    adQueue.add(() => {
        const adName = stripDfpAdPrefixFrom(advert.id);
        eventTimer.mark('adRenderStart', adName);
        // TODO can slotReady come after header bidding?
        // If so, the callbacks pushed onto the ias queue in define-slot.js
        // could be run in parallel with the calls to requestBids below, reducing the
        // total time to display the ad.
        void advert.whenSlotReady
            .catch(() => {
            // The display needs to be called, even in the event of an error.
        })
            .then(() => {
            eventTimer.mark('prepareSlotStart', adName);
            // If the advert has already had bids requested, then we don't need to request them again.
            if (advert.headerBiddingBidRequest) {
                return advert.headerBiddingBidRequest;
            }
            return requestBidsForAd(advert);
        })
            .then(() => {
            eventTimer.mark('prepareSlotEnd', adName);
            eventTimer.mark('fetchAdStart', adName);
            window.googletag.display(advert.id);
        });
    }, true);
};
export const refreshAdvert = (advert) => {
    // advert.size contains the effective size being displayed prior to refreshing
    adQueue.add(() => {
        void advert.whenSlotReady
            .then(() => fastdom.mutate(() => {
            if (advert.id.includes('fronts-banner')) {
                advert.node
                    .closest('.ad-slot-container')
                    ?.classList.remove('ad-slot--full-width');
            }
        }))
            .then(() => {
            return refreshBidsForAd(advert);
        })
            .then(() => {
            advert.slot.setConfig({
                targeting: {
                    refreshed: 'true',
                },
            });
            // slots that have refreshed are not eligible for teads
            advert.slot.setConfig({
                targeting: {
                    teadsEligible: 'false',
                },
            });
            if (advert.id === 'dfp-ad--top-above-nav') {
                // force the slot sizes to be the same as advert.size (current)
                // only when advert.size is an array (forget 'fluid' and other specials)
                if (Array.isArray(advert.size)) {
                    const mapping = window.googletag
                        .sizeMapping()
                        .addSize([0, 0], advert.size)
                        .build();
                    if (mapping)
                        advert.slot.defineSizeMapping(mapping);
                }
            }
            window.googletag.pubads().refresh([advert.slot]);
        });
    });
};
